import React from 'react'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import Config from 'organization/Event/Configurable/Config'
import {TemplateSave, useSaveTemplate} from 'Event/TemplateUpdateProvider'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import Styling from './Styling'
import {AgendaListSettings} from 'Event/template/Panels/Dashboard/AgendaList'
import Settings from './Settings'
import {Template} from 'Event/template'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useAddTranslation} from 'Event/LanguageProvider'

export function AgendaListConfig(props: {agendaList: AgendaListSettings}) {
  const {agendaList} = props
  const addTranslation = useAddTranslation()

  const save = useSaveTemplate()
  const handleSave: TemplateSave<Template> = (data) => {
    const title = replaceAtPath(
      data,
      'agendaList.title',
      '{{agenda_list_page_title}}',
    )

    const menuTitle = replaceAtPath(
      data,
      'agendaList.menuTitle',
      '{{agenda_list_menu_title}}',
    )

    const description = replaceAtPath(
      data,
      'agendaList.description',
      '{{agenda_list_description}}',
    )

    save({
      ...data,
      localization: addTranslation({
        agenda_list_page_title: title ?? 'Agendas',
        agenda_list_menu_title: menuTitle ?? 'Agendas',
        agenda_list_description: description ?? '',
      }),
    })
  }

  return (
    <Config title="Agendas" onSave={handleSave}>
      <SettingsPanel>
        <Settings agendaList={agendaList} />
      </SettingsPanel>
      <StylingPanel>
        <Styling agendaList={agendaList} />
      </StylingPanel>
    </Config>
  )
}
